import React from 'react';
import {useSelector} from 'react-redux';
import Online from '../component/Online';
import Test from '../component/Test';

const CapacitationPage = (props) => {
  const token = useSelector((state) => state.authentication.user.token);
  const SwitchCapacitation = (props) => {
    switch (props.location.state.modality) {
      case 0:
        return (
          <Online
            data={{
              iD_Course: props.location.state.iD_Course,
              iD_Instance: props.location.state.iD_Instance,
              expired: props.location.state.expired,
            }}
          />
        );
      case 1:
        return (
          <Test
            data={{
              iD_Course: props.location.state.iD_Course,
              iD_Instance: props.location.state.iD_Instance,
              cwid: props.location.state.cwid,
              tablet: true,
              token: token,
              expired: props.location.state.expired,
            }}
          />
        );
      case 2:
        return <h1>En papel</h1>;
      default:
        return <h1>bad :(</h1>;
    }
  };

  return <>{SwitchCapacitation(props)}</>;
};

export default CapacitationPage;
